
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" ></ngx-loading>
<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Update Password</h5>
   
    <button type="button" class="close" aria-hidden="true" (click)="closeModal()"> <i aria-hidden="true" class="ki ki-close"></i></button>
</div>
<div class="modal-body">
    <form class="form pl-5 pr-5 " [formGroup]="profileForm"  autocomplete="off">
   
        <!--end::Alert-->
       
        <div class="form-group">
            <label>New Password <span class="asterisk">*</span></label>
            <input type="password" class="form-control form-control-lg form-control-solid" formControlName="newPassowrd" required  placeholder="New password">
                <div  class="fv-plugins-message-container">
                    <div class="fv-help-block"> Must contain minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character </div></div>
          
        </div>
    
        <div class="form-group">
            <label>Verify Password <span class="asterisk">*</span></label>
            <input type="password" class="form-control form-control-lg form-control-solid" formControlName="confirm_password" required placeholder="Verify password">
       
        </div>
     
        </form>
</div>
<div class="modal-footer">
    <!-- <button type="button" class="btn btn-light-primary font-weight-bold" data-dismiss="modal" (click)="closeModal()">Close</button> -->
    <button type="button" class="btn btn-primary font-weight-bold"  [disabled]="!profileForm.valid" (click)="submit()">Update Password</button>
</div>